import { API_GATEWAY, PR_DEP } from "../../config/globalVariables";
import axios from "axios";
import {
  defaultAlertMessages,
  getConfirmErrorMessage,
  getConfirmSuccessMessage,
} from "../../utils/common";
import { confirmAlert } from "react-confirm-alert";
import {
  toDataSourceRequestString,
  translateDataSourceResultGroups,
} from "@progress/kendo-data-query";
import { getAccessToken } from "../../helpers/authConfig";

class ParticipantService {
  getParticipantFields() {
    return axios
      .get(`${API_GATEWAY + PR_DEP}/katilimcialan/get-list`)
      .then((response) => {
        return response.data;
      });
  }

  getEventParticipantsByEventId(eventId) {
    return axios
      .get(
        `${API_GATEWAY + PR_DEP}/etkinlikkatilimci/get-by-event-id/${eventId}`
      )
      .then((response) => {
        return response.data;
      });
  }

  getParticipantsForExcel(dataState) {
    return axios
      .get(
        `${
          API_GATEWAY + PR_DEP
        }/etkinlikkatilimci/get-list-for-excel?${toDataSourceRequestString(
          dataState
        )}`
      )
      .then((response) => response.data);
  }

  getEventParticipantFieldsByEventId(eventId) {
    return axios
      .get(
        `${
          API_GATEWAY + PR_DEP
        }/etkinlikkatilimcialan/get-by-event-id/${eventId}`
      )
      .then((response) => {
        return response.data;
      });
  }

  getEventParticipant(id) {
    return axios
      .get(`${API_GATEWAY + PR_DEP}/etkinlikkatilimci/get-by-id/${id}`)
      .then((response) => {
        return response.data;
      });
  }

  getEventParticipants(dataState) {
    return axios
      .get(
        `${
          API_GATEWAY + PR_DEP
        }/etkinlikkatilimci/get-list-by-filter?${toDataSourceRequestString(
          dataState
        )}`
      )
      .then((response) => {
        return dataState.group && dataState.group.length
          ? translateDataSourceResultGroups(response.data)
          : { data: response.data, dataState };
      });
  }

  addEventParticipant(data) {
    return axios
      .post(`${API_GATEWAY + PR_DEP}/etkinlikkatilimci/add`, { ...data })
      .then((response) => {
        defaultAlertMessages.MessageDetailSuccess = response.message;
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmSuccessMessage(onClose, defaultAlertMessages);
          },
        });
        return response;
      })
      .catch((err) => {
        defaultAlertMessages.MessageDetailError = JSON.stringify(
          err.response.data
        );
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmErrorMessage(onClose, defaultAlertMessages);
          },
        });
      });
  }

  deleteEventParticipant(id) {
    return axios
      .post(`${API_GATEWAY + PR_DEP}/etkinlikkatilimci/delete/${id}`)
      .then((response) => {
        defaultAlertMessages.MessageDetailSuccess = response.message;
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmSuccessMessage(onClose, defaultAlertMessages);
          },
        });
        return response;
      })
      .catch((err) => {
        defaultAlertMessages.MessageDetailError = JSON.stringify(
          err.response.data
        );
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmErrorMessage(onClose, defaultAlertMessages);
          },
        });
      });
  }

  addEventDaikinParticipant(data) {
    return axios
      .post(
        `${
          API_GATEWAY + PR_DEP
        }/etkinlikkatilimci/add-participant-daikin-personel`,
        { ...data }
      )
      .then((response) => {
        defaultAlertMessages.MessageDetailSuccess = response.message;
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmSuccessMessage(onClose, defaultAlertMessages);
          },
        });
        return response;
      })
      .catch((err) => {
        defaultAlertMessages.MessageDetailError = JSON.stringify(
          err.response.data
        );
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmErrorMessage(onClose, defaultAlertMessages);
          },
        });
      });
  }

  updateEventParticipant(data) {
    return axios
      .post(`${API_GATEWAY + PR_DEP}/etkinlikkatilimci/update`, { ...data })
      .then((response) => {
        defaultAlertMessages.MessageDetailSuccess = response.message;
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmSuccessMessage(onClose, defaultAlertMessages);
          },
        });
        return response;
      })
      .catch((err) => {
        defaultAlertMessages.MessageDetailError = JSON.stringify(
          err.response.data
        );
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmErrorMessage(onClose, defaultAlertMessages);
          },
        });
      });
  }

  addEventParticipantFields(data) {
    return axios
      .post(`${API_GATEWAY + PR_DEP}/etkinlikkatilimcialan/add`, { ...data })
      .then((response) => {
        defaultAlertMessages.MessageDetailSuccess = response.message;
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmSuccessMessage(onClose, defaultAlertMessages);
          },
        });
        return response;
      })
      .catch((err) => {
        defaultAlertMessages.MessageDetailError = JSON.stringify(
          err.response.data
        );
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmErrorMessage(onClose, defaultAlertMessages);
          },
        });
      });
  }

  sendMailToParticipants(data) {
    return axios
      .post(
        `${API_GATEWAY + PR_DEP}/etkinlikkatilimci/send-notification`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then((response) => {
        defaultAlertMessages.MessageDetailSuccess = response.message;
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmSuccessMessage(onClose, defaultAlertMessages);
          },
        });
        return response;
      })
      .catch((err) => {
        defaultAlertMessages.MessageDetailError = JSON.stringify(
          err.response.data
        );
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmErrorMessage(onClose, defaultAlertMessages);
          },
        });
      });
  }

  async sendInvitationToParticipants(data) {
    const token = await getAccessToken();
    return axios
      .post(`${API_GATEWAY + PR_DEP}/etkinlikkatilimci/send-invitation`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Azure-Token": token,
        },
      })
      .then((response) => {
        defaultAlertMessages.MessageDetailSuccess = response.message;
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmSuccessMessage(onClose, defaultAlertMessages);
          },
        });
        return response;
      })
      .catch((err) => {
        defaultAlertMessages.MessageDetailError = JSON.stringify(
          err.response.data
        );
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmErrorMessage(onClose, defaultAlertMessages);
          },
        });
      });
  }

  async sendInvitationUpdateToParticipants(data) {
    const token = await getAccessToken();
    return axios
      .post(
        `${API_GATEWAY + PR_DEP}/etkinlikkatilimci/send-updated-invitation`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "Azure-Token": token,
          },
        }
      )
      .then((response) => {
        defaultAlertMessages.MessageDetailSuccess = response.message;
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmSuccessMessage(onClose, defaultAlertMessages);
          },
        });
        return response;
      })
      .catch((err) => {
        defaultAlertMessages.MessageDetailError = JSON.stringify(
          err.response.data
        );
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmErrorMessage(onClose, defaultAlertMessages);
          },
        });
      });
  }
  sendReminderailToParticipants(data) {
    return axios
      .post(`${API_GATEWAY + PR_DEP}/etkinlikkatilimci/send-reminder`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        defaultAlertMessages.MessageDetailSuccess = response.message;
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmSuccessMessage(onClose, defaultAlertMessages);
          },
        });
        return response;
      })
      .catch((err) => {
        defaultAlertMessages.MessageDetailError = JSON.stringify(
          err.response.data
        );
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmErrorMessage(onClose, defaultAlertMessages);
          },
        });
      });
  }

  async getParticipantResponses(eventId) {
    const token = await getAccessToken();
    return axios
      .get(
        `${
          API_GATEWAY + PR_DEP
        }/etkinlikkatilimci/get-participant-responses/${eventId}`,
        {
          headers: {
            "Azure-Token": token,
          },
        }
      )
      .then((response) => {
        return response.data;
      });
  }

  getParticipationStatistics(eventId) {
    return axios
      .get(
        `${
          API_GATEWAY + PR_DEP
        }/etkinlikkatilimci/get-participation-statistics/${eventId}`
      )
      .then((response) => {
        return response.data;
      });
  }
}

export default new ParticipantService();
